export function warnOnce(componentName) {
    var didWarn = {};
    return function(message) {
        var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "warn";
        if (!didWarn[message]) {
            console[type]("[@vkontakte/icons][".concat(componentName, "] ").concat(message));
            didWarn[message] = true;
        }
    };
}
